var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.7957 9.70347C29.5117 10.4194 29.5117 11.5802 28.7957 12.2962L19.0921 21.9998L28.7957 31.7035C29.5117 32.4194 29.5117 33.5802 28.7957 34.2962C28.0798 35.0122 26.9189 35.0122 26.203 34.2962L15.203 23.2962C14.487 22.5802 14.487 21.4194 15.203 20.7035L26.203 9.70347C26.9189 8.98751 28.0798 8.98751 28.7957 9.70347Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronLeft);
export default __webpack_public_path__ + "static/media/chevron-left.f79c12308e72eef1794dcdbe91214bc5.svg";
export { ForwardRef as ReactComponent };